import React from "react";
import { Row, Col } from "react-bootstrap";

import { ButtonsContainer } from "../../IncidentReportForm";

import Capas from "../../../Capas";
import CapasComponent from "app/_pages/_healthSafetyEnvironment/CapasComponent";

const AddEditCapa = ({
  form = {},
  //onChange,
  error = {},
  setTab,
  onSubmit,
  capas,
  capasErrors,
  onChangeCapa,
  addCapa,
  deleteCapa,
  siteId,
  users,
  departments,
  area,
  subArea,
  capaowner,
  noButton,
  viewOnly,
  approveCapa,
  approverLevel,
  hideTitle = false,
  isValidDate,
  showReject,
}) => {
  //const [form, setForm] = useState({ ...initialCapa, siteId: siteId || "" });
  //const [errorForm, setErrorForm] = useState({ ...initialCapa, source: "", capaStatus: "" });
  //const [users, setUsers] = useState([]);
  //const [departments, setDepartments] = useState([]);
  //const [sites, setSites] = useState([]);
  ///const [workAreas, setWorkAreas] = useState([]);
  //const [id, setid] = useState(2);

  return (
    <div className={hideTitle ? "" : "card p-3 pb-0 mt-4 EHS_module_create_form"}>
      {!hideTitle && (
        <div className="simple-card-title">
          <h3 class="text-capitalize mb-0"></h3>
        </div>
      )}
      <Row className="mb-4 justify-content-start align-items-center pl-2">
        <Col lg={4}>
          <span className="small text-danger">{error?.reportEvidencesRequired}</span>
        </Col>
      </Row>
      <div className="ehsFormWrapper">
        <div className="w-100">
          {form?.severity < 4 && form?.reportAtLabel === "ro" && form.closeIncident ? (
            <CapasComponent
              capas={capas}
              capasErrors={capasErrors}
              onChangeCapa={onChangeCapa}
              addCapa={addCapa}
              deleteCapa={deleteCapa}
              users={users}
              departments={departments}
              area={area}
              incidentsOnly
              capaowner={capaowner}
              viewOnly={viewOnly}
              approveCapa={approveCapa}
              form={form}
              siteId={siteId}
              showReject
            />
          ) : (
            <Capas
              capas={capas}
              capasErrors={capasErrors}
              onChangeCapa={onChangeCapa}
              addCapa={addCapa}
              deleteCapa={deleteCapa}
              users={users}
              departments={departments}
              area={area}
              incidentsOnly
              capaowner={capaowner}
              viewOnly={viewOnly}
              approveCapa={approveCapa}
              form={form}
              approverLevel={approverLevel}
              isValidDate={isValidDate}
              siteId={siteId}
              showReject
            />
          )}
        </div>
      </div>

      {!noButton && (
        <ButtonsContainer
          incidentStatus={form.incidentStatus}
          setTab={setTab}
          closeIncident={form.closeIncident}
          prev={5}
          noNext
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};

export default AddEditCapa;
